import React, { useEffect } from "react";
import { ThemeProvider } from '@mui/material/styles';
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import {Footer} from "../Footer/Footer";
import {CircularProgress, useMediaQuery} from "@mui/material";
import {useQueryUser} from "../../../queries/user/hooks/useQueryUser";
import NewPharmacy from "../NewPharmacy/NewPharmacy";
import PharmacyInfo from "../NewPharmacy/PharmacyInfo/PharmacyInfo";
import Routes from "../../Routes/Routes";
import {useQueryUniqueUsers} from "../../../queries/pharmacy/hooks/useQueryUniqueUsers";
import {ShoppingCartContextProvider} from "../../shared/ShoppingCart/ShoppingCartContextProvider";
import {contextObject} from "../../shared/ShoppingCart/ShoppingCartContext";
import {UserContext} from "../../../hooks/userContext";
import {PharmacyContext} from "../../../hooks/pharmacyContext";
import {mdTheme} from "../../../constants/mdTheme";
import {useNavigate} from "react-router-dom";
import AuthHeader from "../AuthLayout/AuthHeader";
import AuthFooter from "../AuthLayout/AuthFooter";
import AuthContent from "../AuthLayout/AuthContent";
import './appLayout.css';
import { routeConfigs } from "../../../navigation/routeConfig";

const AppLayout:React.FunctionComponent<any> = () => {
  const isMobileSize = useMediaQuery('(max-width:600px)');
  const [open, setOpen] = React.useState(!isMobileSize);

  const navigate = useNavigate();

  const {data, loading, error: userError} = useQueryUser();

  const {data: pharmacyUsersData, loading: pharmacyUsersLoading } = useQueryUniqueUsers({
    variables: { where: { id:  +data?.me?.id } },
    skip: !data
  });


  useEffect(() => {
    if (pharmacyUsersData?.findUniqueUser?.id && pharmacyUsersData.findUniqueUser.UserRoles[0]?.Role?.key !== 'admin') {
      const bankAccount = pharmacyUsersData.findUniqueUser.PharmacyUsers[0]?.Pharmacy?.BankAccount.find((item: any)=>(item.object === 'payment_method' || item.object === 'card') && (item.status === 'VERIFIED' || item.status === 'APPROVED'));
      if (!bankAccount) navigate(`${routeConfigs.bankAccount.path}/?required=true`)
    }
  }, [pharmacyUsersData?.findUniqueUser?.id]);


  if (loading || pharmacyUsersLoading) {
    return <CircularProgress sx={{position: 'absolute', left: '50%', top: '50%'}} color="inherit" />
  }

  const status = pharmacyUsersData?.findUniqueUser?.PharmacyUsers[0]?.Pharmacy?.PharmacyStatus?.Status?.key;
  const isAdmin = pharmacyUsersData?.findUniqueUser?.UserRoles[0]?.Role?.key === 'admin';

  if (!data?.me) {
    return <CircularProgress sx={{position: 'absolute', left: '50%', top: '50%'}} color="inherit" />;
  }

  if ((status === 'PENDING' || status === 'REJECTED' || status === 'EXPIRED') && !isAdmin) {
    return (
      <ThemeProvider theme={mdTheme}>
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', backgroundColor: '#FFFFFF', height: '100vh' }}>
          <AuthHeader user={data?.me} pharmacy={pharmacyUsersData.findUniqueUser.PharmacyUsers[0].Pharmacy} />
          <AuthContent>
            <PharmacyInfo status={status} pharmacy={pharmacyUsersData?.findUniqueUser.PharmacyUsers[0]?.Pharmacy} />
          </AuthContent>
          <AuthFooter />
        </Box>
      </ThemeProvider>
    )
  }

  if (!status && !isAdmin) {
    return (
      <ThemeProvider theme={mdTheme}>
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', backgroundColor: '#FFFFFF', height: '100vh' }}>
          <AuthHeader user={data?.me} pharmacy={pharmacyUsersData?.findUniqueUser?.PharmacyUsers[0]?.Pharmacy} />
            <NewPharmacy user={data?.me} />
          <AuthFooter />
        </Box>
      </ThemeProvider>
    )
  }

  return (
    <UserContext.Provider value={data.me}>
      <PharmacyContext.Provider value={pharmacyUsersData.findUniqueUser.PharmacyUsers[0]}>
        <ThemeProvider theme={mdTheme}>
          <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100vh' }}>
            <ShoppingCartContextProvider<any> context={contextObject}>
              <Box sx={{ display: 'flex', flex: '1' }}>
                <CssBaseline />
                <Header
                  user={data?.me}
                  pharmacy={pharmacyUsersData?.findUniqueUser?.PharmacyUsers[0]?.Pharmacy}
                  setOpen={setOpen}
                  isAdmin={isAdmin}
                  open={open}
                />
                <Sidebar open={open} setOpen={setOpen} isAdmin={isAdmin} />
                <Box
                  component="main"
                  sx={{
                    backgroundColor: (theme) =>
                      theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[900],
                    flexGrow: 1,
                    overflow: 'auto',
                  }}
                >
                  <Toolbar />
                  <Container sx={{ pt: 3, width: '100%', overflow: 'auto', maxWidth: 'none !important' }}>
                    <Grid sx={{ height: '100%' }} container spacing={3}>
                      <Grid item xs={12}>
                        <Routes isAdmin={isAdmin} />
                      </Grid>
                    </Grid>
                  </Container>
                </Box>
              </Box>
            </ShoppingCartContextProvider>
            <Footer />
          </Box>
        </ThemeProvider>
      </PharmacyContext.Provider>
    </UserContext.Provider>
  )
}

export default AppLayout;